/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import React from 'react';
import { Row, Col } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import FieldSettings from './FieldSettings';
import textIcon from '../../asset/text.svg';
import richTextIcon from '../../asset/richtext.svg';
import mediaIcon from '../../asset/media.svg';
import draggableIcon from '../../asset/draggable.png';
import dateIcon from '../../component/DatePicker/Date.svg';
import { CSubtitle1, CBody2 } from '../../component/Text';
import CButton from '../../component/Button/index';
import { setCustomTypeDraft } from '../../actions/CustomTypeAction';

const divStyle = {
  borderTop: '1px solid #F0F4FF',
  overflow: 'hidden',
  padding: '28px 40px 28px 35px',
  width: '100%'
};

const CustomImage = ({ type, customHeight, customWidth }) => {
  let path;

  switch (type) {
    case 'text':
      path = textIcon;
      break;
    case 'tinymce':
      path = richTextIcon;
      break;
    case 'file':
      path = mediaIcon;
      break;
    case 'files':
      path = mediaIcon;
      break;
    case 'checkbox':
      path = textIcon;
      break;
    case 'list':
      path = richTextIcon;
      break;
    case 'draggable':
      path = draggableIcon;
      break;
    case 'date':
      path = dateIcon;
      break;
    case 'complex list':
      path = richTextIcon;
      break;
    case 'Connect To Content':
      path = richTextIcon;
      break;
    case 'Select':
      path = richTextIcon;
      break;
    default:
  }

  return <img alt="" height={customHeight || 25} src={path} width={customWidth || 25} />;
};

// const typeReadable = (type) => {
//   switch (type) {
//     case "text":
//       return "Text";
//     case "tinymce":
//       return "RichText";
//     case "file":
//       return "Media";
//     case "checkbox":
//       return "Checkbox";
//     default:
//       return "Text";
//   }
// };

const ContentModelField = ({ field, DragHandle, setDeletedFieldInfo }) => {
  const dispatch = useDispatch();
  const customTypeDraft = useSelector(({ customType }) => customType.customTypeDraft);
  const currentProject = useSelector(({ project }) => project.currentProject);
  const [settingsModalVisible, setSettingsModalVisible] = React.useState(false);
  const { field_name, field_type, label, field_addition } = field;

  const toggleSettingsModal = () => {
    setSettingsModalVisible(!settingsModalVisible);
  };

  const settingsModalOk = ({ name, apiId, type, props, oldApiId }) => {
    // onFieldRemove();
    let newFieldAddition = {};
    if (Object.keys(props) === 0) {
      const oldFieldAddition = customTypeDraft.template[apiId].field_addition;
      newFieldAddition = { ...oldFieldAddition };
    } else {
      onFieldRemove();
      newFieldAddition = { ...props };
    }

    dispatch(
      setCustomTypeDraft({
        ...customTypeDraft,
        template: {
          ...customTypeDraft.template,
          [apiId]: {
            field_addition: { ...newFieldAddition },
            field_name: apiId,
            field_type: type,
            label: name
          }
        }
      })
    );

    // if (oldApiId !== apiId) {
    //   customTypeDraft.content.forEach(async (contentId) => {
    //     const response = await getContentById(contentId, currentProject._id);
    //     const { content } = response.data;
    //     // console.log(response.data);
    //     if (!content.data && !Object.keys(content.data)) return;
    //     Object.keys(content.data).forEach(async (lang) => {
    //       // console.log(content.data);
    //       if (content.data[lang][oldApiId]) {
    //         // console.log(content.data[lang][oldApiId]);
    //         const fieldData = content.data[lang];
    //         // console.log(fieldData);
    //         // delete content.data[lang][oldApiId];
    //         await updateContent(
    //           {
    //             ...content,
    //             data: {
    //               ...content.data,
    //               [lang]: {
    //                 ...content.data[lang],
    //                 [field]: fieldData
    //               }
    //             }
    //           },
    //           contentId,
    //           currentProject._id
    //         );
    //       }
    //     });
    //   });
    // }

    toggleSettingsModal();
  };

  const onFieldRemove = () => {
    delete customTypeDraft.template[field_name];
    delete customTypeDraft.template[label];
    dispatch(setCustomTypeDraft({ ...customTypeDraft }));
    setDeletedFieldInfo((oldObj) => [
      ...oldObj,
      {
        fieldName: field_name,
        fieldType: field_type,
        removeType: 'field'
      }
    ]);
  };

  const onFieldKeyRemove = (fieldId, key) => {
    setDeletedFieldInfo((oldObj) => [
      ...oldObj,
      {
        fieldName: fieldId,
        fieldType: field_type,
        key,
        removeType: 'field key'
      }
    ]);
  };

  return (
    <div style={divStyle}>
      <FieldSettings
        field_addition={field_addition}
        fieldType={field_type}
        label={label}
        nameField={field_name}
        oldFieldAddition={customTypeDraft?.template[field_name]?.field_addition}
        onCancel={toggleSettingsModal}
        onFieldKeyRemove={onFieldKeyRemove}
        onOk={settingsModalOk}
        visible={settingsModalVisible}
      />
      <Row align="middle" style={{ height: '56px' }}>
        <Col align="start" span={16}>
          <Row align="middle" gutter={16} justify="start">
            <Col>
              <DragHandle />
            </Col>
            <Col
              style={{
                background: '#F0F4FF',
                borderRadius: '4px',
                margin: '0px 24px 0px 32px',
                padding: '7px'
              }}
            >
              <CustomImage type={field_type} />
            </Col>
            <Col span={6}>
              <CSubtitle1>{label}</CSubtitle1>
            </Col>
            <Col>
              <CBody2>{field_name}</CBody2>
            </Col>
          </Row>
        </Col>
        <Col align="end" span={8}>
          <Row align="middle" gutter={8} justify="end">
            <Col align="end" justify="space-between" span={16}>
              <CButton
                onClick={toggleSettingsModal}
                type="edit"
                xstyle={{
                  marginRight: '16px'
                }}
              >
                Edit
              </CButton>
              <CButton onClick={onFieldRemove} type="edit">
                Delete
              </CButton>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default ContentModelField;
